import React from 'react';
import PropTypes from 'prop-types';
import { Hue, Alpha } from 'react-color/lib/components/common';
import Pointer from './pointer';
import toRgbaColor from '../helpers/to-rgba-color';
import huePointerColor from '../helpers/hue-pointer-color';

function ColorPattern(props) {
  const { rgb, enableAlpha } = props;
  return (
    <div className="ws-ui-color-picker__color-pattern">
      <div
        className="ws-ui-color-picker__color-example"
        style={{ backgroundColor: toRgbaColor(rgb) }}
      />
      <div className="ws-ui-color-picker__sliders-wrapper">
        <div className="ws-ui-color-picker__slider">
          <Hue
            {...props}
            pointer={(color) => <Pointer color={huePointerColor(color.hsl)} />}
            direction="horizontal"
          />
        </div>
        {enableAlpha && (
          <div className="ws-ui-color-picker__slider">
            <Alpha
              {...props}
              pointer={(color) => <Pointer color={toRgbaColor(color.rgb)} />}
              direction="horizontal"
            />
          </div>
        )}
      </div>
    </div>
  );
}

ColorPattern.propTypes = {
  rgb: PropTypes.shape({
    r: PropTypes.number,
    g: PropTypes.number,
    b: PropTypes.number,
    a: PropTypes.number,
  }).isRequired,
  enableAlpha: PropTypes.bool.isRequired,
};

export default ColorPattern;
